import { render, staticRenderFns } from "./DashboardTeachTime.vue?vue&type=template&id=664b82c0&"
import script from "./DashboardTeachTime.vue?vue&type=script&lang=ts&"
export * from "./DashboardTeachTime.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardTeachTime.vue?vue&type=style&index=0&id=664b82c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports